import { useLocalStorage } from 'hooks/useLocalStorage';
import { useCallback, useState } from 'react';

export enum OnboardingStep {
  Step1 = 1,
  Step2,
  Step3,
  Step4,
}

export function useOnboardingState(): {
  isCompleted: boolean;
  setCompleted: () => void;
  step: OnboardingStep;
  goToPreviousStep: () => void;
  goToNextStep: () => void;
} {
  const [isCompleted, setCompletedState] = useLocalStorage(
    'navigationOnboardingCompleted',
    false
  );
  const [step, setStep] = useState<OnboardingStep>(OnboardingStep.Step1);
  const goToPreviousStep = useCallback(() => {
    setStep((step) => (step > OnboardingStep.Step1 ? step - 1 : step));
  }, []);
  const goToNextStep = useCallback(() => {
    setStep((step) => (step < OnboardingStep.Step4 ? step + 1 : step));
  }, []);
  const setCompleted = useCallback(() => {
    setCompletedState(true);
  }, [setCompletedState]);

  return { isCompleted, setCompleted, step, goToPreviousStep, goToNextStep };
}
